import { hero } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="relative paper-noise">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          {/* text block */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#fff7ed] bg-[#c2410c] rounded-full px-3 py-1">
                <i className="ri-fire-fill"></i>
                {hero.kick}
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-[#a35f35] bg-[#f0e2d0] rounded-full px-3 py-1 whitespace-nowrap">
                <i className="ri-time-line"></i>
                {hero.overline}
              </span>
            </div>

            <h1 className="font-display text-[32px] leading-[1.18] md:text-[44px] font-bold text-[#241c15] tracking-tight">
              {hero.title}
            </h1>

            <p className="editorial-lead mt-5 text-[15px] leading-7 text-[#5b4f45] max-w-[560px]">
              {hero.lead}
            </p>

            <div className="flex flex-wrap gap-2 mt-5">
              {hero.tags.map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-1 text-xs text-[#7a6a58] bg-white border border-[#e7d6c1] rounded-full px-3 py-1"
                >
                  <i className="ri-price-tag-3-line text-[#c2410c]"></i>
                  {t}
                </span>
              ))}
            </div>

            <div className="flex flex-wrap items-center gap-3 mt-6">
              <a
                href="#full"
                className="inline-flex items-center gap-2 text-sm font-semibold text-[#fff7ed] bg-[#c2410c] rounded-md px-5 py-3 whitespace-nowrap hover:bg-[#9a3408] transition-colors cursor-pointer"
              >
                查看完整时间线
                <i className="ri-arrow-down-line text-lg"></i>
              </a>
              <a
                href="#deep"
                className="inline-flex items-center gap-2 text-sm font-semibold text-[#241c15] bg-white border border-[#e0c9ae] rounded-md px-5 py-3 whitespace-nowrap hover:border-[#c2410c] hover:text-[#c2410c] transition-colors cursor-pointer"
              >
                <i className="ri-search-eye-line text-lg"></i>
                阅读深度复盘
              </a>
            </div>

            <p className="mt-4 text-xs text-[#9a8772] flex items-center gap-2">
              <i className="ri-line-chart-fill text-[#c2410c]"></i>
              {hero.meta}
            </p>
          </div>

          {/* image block */}
          <div className="lg:col-span-6 order-1 lg:order-2 relative">
            <div className="relative overflow-hidden rounded-2xl border-4 border-white shadow-[0_10px_30px_-12px_rgba(122,106,88,0.5)]">
              <img
                src={hero.image}
                alt="直播电商年货节翻车事件幕后直播间场景，编辑部新闻配图"
                className="w-full aspect-[4/3] lg:aspect-[5/4] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#241c15]/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 px-5 pb-4 pt-10 flex items-end justify-between gap-3">
                <span className="text-xs text-[#fff7ed]/90">
                  <i className="ri-edit-line mr-1"></i>摄制现场实录 · 编辑部配图
                </span>
              </div>
            </div>
            <div className="absolute -top-4 -right-3 md:top-5 md:-right-5 bg-[#201a14] text-[#ffe9d6] rounded-xl px-4 py-3 rotate-2 border border-[#4a3a2c]">
              <div className="font-number text-3xl leading-none text-orange-400">168h</div>
              <div className="text-[10px] text-[#c9b49c] mt-1 whitespace-nowrap">持续跟踪时长</div>
            </div>
            <div className="absolute -bottom-4 left-5 bg-white rounded-xl px-4 py-3 -rotate-1 border border-[#ead9c5]">
              <div className="flex items-center gap-2">
                <span className="relative flex w-2.5 h-2.5">
                  <span className="animate-hotpulse inline-flex w-2.5 h-2.5 rounded-full bg-orange-500"></span>
                </span>
                <span className="text-sm font-semibold text-[#241c15]">舆情监测中</span>
              </div>
              <div className="text-[11px] text-[#9a8772] mt-0.5">顶栏进展将持续更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}